import Api from "../config/Axios";


export const getList = (token, user_id, data) => {
  const config = {headers: {Authorization: "Bearer " + (token ? token : localStorage.getItem("token")), UserId: parseInt(user_id ? user_id : localStorage.getItem("user_id"))}};
  return Api.get(`api/web/trigger/list`, {params:data, ...config});
};

export const patchEdit = (token, user_id, data) => {
  const config = {headers: {Authorization: "Bearer " + (token ? token : localStorage.getItem("token")), UserId: parseInt(user_id ? user_id : localStorage.getItem("user_id"))}};
  return Api.patch(`api/web/trigger/update`, data, config);
};